var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2526_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6361 17.2574C14.4504 18.0427 13.0286 18.5 11.5 18.5C7.35786 18.5 4 15.1421 4 11C4 6.85786 7.35786 3.5 11.5 3.5C15.6421 3.5 19 6.85786 19 11C19 12.7105 18.4274 14.2873 17.4633 15.5491L20.9498 19.0356L19.182 20.8033L15.6361 17.2574ZM17 11C17 14.0376 14.5376 16.5 11.5 16.5C8.46243 16.5 6 14.0376 6 11C6 7.96243 8.46243 5.5 11.5 5.5C14.5376 5.5 17 7.96243 17 11Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2526_9275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.17f14346ef897df2913a6cb75d6a13b6.svg";
export { ForwardRef as ReactComponent };